<template>
  <div class="hello" v-if="mask">
    <div class="hidden">{{getImage(mask)}}</div>
    <div class="container">
      <div class="progressbar-container" v-if="progress > 0 && uploading">
        <div id="progressbar" v-bind:style="{width: progress+'%'}"></div>
      </div>
      <div class="item-header">
        <input id="input-mask-name" type="text" v-model="mask.name" name="name">
      </div>
      <div class="image-wrapper" :style="{background: 'url(' + mask.thumbURL +') center center/cover no-repeat'}">
      </div>

      <div class="file-input-container">
        <input type="file"
          id="fileChooser"
          name="image"
          :disabled="uploading"
          @change="filesChange($event.target.name, $event.target.files[0]);
          fileCount = $event.target.files.length"
            accept="image/*" class="input-file upload_btn">
      </div>


        <div class="overlay-layer">Upload Photo</div>
    </div>
    <div class="container">
      <div class="item-settings">
        <div>Search Words</div>
        <div contenteditable id="input-description" @blur="updateDescription">
          {{mask.description}}
        </div>
      </div>
    </div>
    <div class="container">
      <div class="item-settings">
        <div>Quantity</div>
        <div id="available-container">
          <button @click="subtract" :disabled="mask.available == 0" class="quantity-button subtract" id="subtract">
            <font-awesome-icon icon="minus" /></button>
          <input id="input-available" type="number" pattern="[0-9]*" v-model="mask.available" name="available">
          <button @click="add" class="quantity-button add" id="add">
            <font-awesome-icon icon="plus" /></button>
        </div>
      </div>
    </div>
    <div class="container">
      <button @click="save">{{progress > 0 && uploading ? 'UPLOADING' : 'SAVE'}}</button>
    </div>
  </div>
</template>

<script>
import {auth,  storage, masksRef} from '../firebase/firebaseConfig'
import {mapGetters} from 'vuex'
export default {
  name: 'EditMask',
  props: {},
  data: function (){
    return {
      uploading: false,
      progress: 0,
      imageURL: null,
      thumbURL: null
    }
  },
  created() {
  },
  mounted () {
  },
  methods: {
    add() {
      this.mask.available++
    },
    subtract() {
      this.mask.available--
    },
    updateDescription(e) {
      this.mask.description = e.target.innerText
    },
    async getImage (maskElement) {
      let vm = this
      // if the maskElement has the public url return it
      if (maskElement.imageURL) {
        vm.imageURL = maskElement.imageUrl
      } else {
        setTimeout(function(){
          var pathReference = storage.ref(maskElement.image);
          pathReference.getDownloadURL().then(function(url) {
            vm.imageURL = url
            masksRef.doc(maskElement.uuid).update(
              {imageURL: url}
            ).then(function() {
              console.log('updated imgURL')
            }).catch(function(error) {
              console.log('error2', error)
            })
          }).catch(function(error) {
            console.log('error4', error)
          })
        }, 1000)
      }

      // if the maskElement has the public url return it
      if (maskElement.thumbURL) {
        return maskElement.thumbURL
      } else {
        setTimeout(function(){
          var pathReferenceThumb = storage.ref(maskElement.thumb);
          pathReferenceThumb.getDownloadURL().then(function(url) {
            vm.thumbURL = url
            masksRef.doc(maskElement.uuid).update(
              {thumbURL: url}
            ).then(function() {
            }).catch(function(error) {
              console.log('error2', error)
            })
          }).catch(function(error) {
            console.log('error44', error)
          })
        }, 1000);
      }
    },
    filesChange: function(a,file) {
      let vm = this
      let timeStamp = Date.now()
      let newName = this.maskPath + '/' + timeStamp + '-' + file.name
      var extention = newName.lastIndexOf('.');
      var t = document.createTextNode(newName);
      t.insertData(extention, '_300x169');
      let thumbName = t.data

      let storageRef = storage.ref(newName)
      let oldImage = storage.ref(vm.mask.image)
      let oldThumb = null
      if(vm.mask.thumb){
        oldThumb = storage.ref(vm.mask.thumb)
      }
      let task = storageRef.put(file)

      task.on('state_changed',
        function progress(snapshot) {
          vm.uploading = true
          vm.progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
        },
        function error(err) {
          console.log('error1', err)
        vm.uploading = false
        },
        function complete() {
        vm.uploading = false
        vm.mask.image = newName
        vm.mask.thumb = thumbName
        vm.mask.thumbURL = null
        vm.mask.imageURL = null
        masksRef.doc(vm.mask.uuid).update(
          {...vm.mask}
        ).then(function() {
          if (oldImage.fullPath != vm.maskPath + '/oro.jpg') {
            oldImage.delete().then(function() {
            }).catch(function(error) {
              console.log('error new thumb', error)
            })

            if(oldThumb) {

              oldThumb.delete().then(function() {
              }).catch(function(error) {
                console.log('error old thumb', error)
              })
            }
          }
        }).catch(function(error) {
          console.log('error2', error)
        })
        }
    )
    },
    save: function () {
      this.mask.available = parseInt(this.mask.available)
      masksRef.doc(this.mask.uuid).update(
        {...this.mask}
      ).then(function() {
      }).catch(function(error) {
        console.log('error', error)
      })
    },
    updateUsername: function() {
      auth.currentUser.updateProfile({
        displayName: this.username
      }).then(function() {
      }).catch(function(error){
        console.log('badness', error)
      })
    },
    login: function() {
      let vm = this
      auth.signInWithEmailAndPassword(this.email, this.password).then(
        function() {
          vm.$router.replace('admin')
        },
        function(err) {
          console.log('aww ', err)
        }
      )
    }
  },
  computed: {
    ...mapGetters(
      {
        getMask: 'getMask'
      }
    ),
    id() {
      return this.$route.params.id
    },
    masks () {
      return this.$store.getters.getMasks
    },
    mask () {
      return this.getMask(this.$route.params.id)
    },
    maskPath () {
      return window.location.host.includes('dev') ? 'masksdev' : 'masks'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.container {
  box-shadow: 0 8px 6px -6px black;
}
button {
  font-weight: bold;
  font-size: 24px;
  background: #e9c46a;
  height: 50px;
  width: 100%;
  border: none;
  cursor: pointer;
}
input, textarea {
  display: inline-block;
  width: 100%;
  padding: 15px 0;
  border: none;
  outline: none;
  font-size: 24px;
  &:focus {
    border: none;
    color: #772e25;
  }
}
.item-header, .item-settings {
  background: white;
    text-align: left;
    padding-left: 20px;
    display: inline-block;
  #input-mask-name {
    font-weight: bold;
  }
}
.item-settings {
  background: none;
  padding: 10px 0;
  display: block;
  margin: auto;
  width: 100%;
  div {
    padding: 5px 10px;
  }
  #input-description {
    padding: 10px;
    font-size: 16px;
    display: block;
    background: white;
    color: black;
    border: 1px solid white;
    outline: none;
    &:focus {
      color: #772e25;
    }
  }
  #input-available {
    width: 50px;
    text-align: center;
    background: none;
    color: white;
    -moz-appearance: textfield;
    &::-webkit-inner-spin-button,
    &::-webkit-outer-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
  }
}
#available-container {
  margin: auto;
  text-align: center;
  button.quantity-button
  {
    border-radius: 4px;
    display: inline-block;
    width: 30%;
    border: 2px solid darkgray;
    background: white;
    box-shadow: 0 8px 6px -6px black;
    &.subtract {
      color: red;
    }
    &.add {
      color: green;
    }
  }
}
#progressbar {
  background: #e9c46a;
  height: 5px;
}
.hidden {
  display: none;
}
.container {
  border: 2px solid white;
  border-radius: 5px;
  margin: 25px auto;
  display: block;
  max-width: 300px;
}

.image-wrapper {
  height: 200px;
}

.overlay-layer{
    display: inline-block;
    width:100%;
    height:100%;
    background-color:#000000;
    z-index:0;
    font-size:18px;
    color:#FFFFFF;
    text-align:center;
    line-height:40px;
}
.file-input-container {
  position: absolute;
  display: block;
  width: 300px;
  height: 50px;
  .upload_btn{
    padding: 0px;
    background: blue;
      z-index:10;
      opacity: 0;
  }
}

</style>
